import { queryOptions, useSuspenseQuery } from '@tanstack/react-query'

import { time } from '@/shared/datetime/utils/time'

import { getApiKey, getApiKeys } from './api'

export const apiKeyKeys = {
	all: ['api-keys'] as const,
	list: () => [...apiKeyKeys.all, 'list'] as const,
	details: () => [...apiKeyKeys.all, 'details'] as const,
	detail: (tenant: string, id: string) =>
		[...apiKeyKeys.details(), tenant, id] as const,
}

export const apiKeyQueries = {
	list: () =>
		queryOptions({
			queryKey: apiKeyKeys.list(),
			queryFn: ({ signal }) => getApiKeys(signal),
			staleTime: time(5, 'm'),
			gcTime: time(15, 'h'),
		}),
	detail: (tenant: string, id: string) =>
		queryOptions({
			queryKey: apiKeyKeys.detail(tenant, id),
			queryFn: ({ signal }) => getApiKey(tenant, id, signal),
			staleTime: time(5, 'm'),
			gcTime: time(15, 'h'),
		}),
}

export const useApiKeys = () => {
	return useSuspenseQuery(apiKeyQueries.list())
}

export const useApiKey = (tenant: string, id: string) => {
	return useSuspenseQuery(apiKeyQueries.detail(tenant, id))
}
